import React from "react";
import { firestore } from "../utils/firebase";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Loading from 'react-fullscreen-loading';
import { Timestamp } from "firebase/firestore";

class PaymentStatus extends React.Component {

    state = {
        checking: true,
        attempts: 0,
        maxAttempts: 10,   // ⏳ Total 10 checks every 4 seconds = 40s wait for webhook
    };

    componentDidMount() {
        this.checkPaymentStatus();
    }

    checkPaymentStatus = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const razorpay_order_id = queryParams.get("razorpay_payment_link_id");

        if (!razorpay_order_id) {
            toast.error("Invalid Payment Link!");
            this.setState({ checking: false });
            return;
        }

        console.log("Checking booking for:", razorpay_order_id);

        try {
            // 🔍 Look for confirmed booking
            const finalRef = firestore
                .collection("booked_parking_order")
                .where("razorpayPaymentLinkID", "==", razorpay_order_id);

            const snapshot = await finalRef.get();

            const finalRef1 = firestore
                .collection("before_extension_booked_parking_order")
                .where("razorpayOrderID", "==", razorpay_order_id)
                .where("cron_status", "==", 1);

            const snapshot1 = await finalRef1.get();

            if (!snapshot.empty) {
                const booking = snapshot.docs[0].data();
                return window.location.href = "/thankyou?order_id=" + booking.id;
            }
            if (!snapshot1.empty) {
                const booking = snapshot1.docs[0].data();
                return window.location.href = "/thankyou?order_id=" + booking.parent_order_id;
            }

            // ⏳ Still pending → Poll again until webhook updates entry
            if (this.state.attempts < this.state.maxAttempts) {
                this.setState({ attempts: this.state.attempts + 1 });

                if (this.state.attempts === 0) {
                    toast.info("Processing payment... please wait");
                }

                setTimeout(this.checkPaymentStatus, 4000);
                return;
            }

            toast.error("Payment verification failed or expired.");
            this.setState({ checking: false });

        } catch (error) {
            console.error(error);
            toast.error("Something went wrong while verifying payment.");
            this.setState({ checking: false });
        }
    };

    retry = () => {
        this.setState({ checking: true, attempts: 0 }, () => {
            this.checkPaymentStatus();
        });
    };

    render() {
        return (
            <div style={{ textAlign: "center", marginTop: "120px" }}>
                {this.state.checking ? (
                    <>
                        <img src="../assets/img/processing.gif" width="80" alt="loading"/>
                        <h3 className="mt-3">Verifying your payment...</h3>
                        <p>Please do not close this page.</p>
                    </>
                ) : (
                    <>
                        <h3 style={{ color: "red" }}>Payment Not Verified</h3>
                        <p>If your money was deducted, it will auto-verify in the next few minutes.</p>

                        <button
                            onClick={this.retry}
                            className="btn btn-primary mt-2"
                            style={{ fontSize: "18px", padding: "10px 24px" }}
                        >
                            Retry
                        </button>

                        <br /><br />

                        {/* <a href="/" style={{ fontSize: "14px", color: "#0a58ca" }}>
                            Go Back Home
                        </a> */}
                    </>
                )}

                <ToastContainer position="bottom-center" />
                <Loading loading={this.state.checking} background="#ffffff80" loaderColor="#4caf50" />
            </div>
        );
    }
}

export default PaymentStatus;
